import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { MsalModule } from '@azure/msal-angular';
import { NgxPubSubModule } from '@pscoped/ngx-pub-sub';
import { EditorModule } from '@progress/kendo-angular-editor';
import { DialogRef, DialogModule } from '@progress/kendo-angular-dialog';
import { EnvironmentsModule } from '../environments/environment-variables.module';
import { HeaderComponent } from './core/header/header.component';
import { FooterComponent } from './core/footer/footer.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthHeaderInterceptor } from './core/interceptors/auth-header-interceptor';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { LoggingService } from './core/services/utils/logging.service';
import { SCAErrorHandler } from './core/interceptors/sca-error-handler';
import { EnvServiceProvider } from './env.service.provider';
import { SessionConfirmModalComponent } from './shared/components/confirm-session-modal/session-confirm-modal.component';
import { HeaderAlertModalComponent } from './shared/components/header-alert-modal/header-alert-modal.component';
import { UnAuthorizedAccessModalComponent } from './shared/components/unauthorized-access-modal/unauthorized-access-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    BreadcrumbComponent,
    HeaderAlertModalComponent,
    SessionConfirmModalComponent,
    UnAuthorizedAccessModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxPubSubModule,
    EnvironmentsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    DialogModule,
    EditorModule,
    NgIdleKeepaliveModule.forRoot(),
    MsalModule.forRoot({
      auth: {
        clientId: environment.config.clientId,
        authority: environment.config.instance,
        redirectUri: environment.config.redirectUri,
        validateAuthority: environment.config.validateAuthority,
        postLogoutRedirectUri: environment.config.postLogoutRedirectUri,
        navigateToLoginRequestUrl: environment.config.navigateToLoginRequestUrl,
      },
      cache: {
        cacheLocation: 'sessionStorage',
      }
    },
      {
        consentScopes: environment.config.consentScopes,
        extraQueryParameters: {}
      })
  ],
  exports: [
    DialogModule,
    HeaderAlertModalComponent,
    SessionConfirmModalComponent,
    UnAuthorizedAccessModalComponent
  ],
  entryComponents: [
    HeaderAlertModalComponent,
    SessionConfirmModalComponent,
    UnAuthorizedAccessModalComponent
  ],
  providers: [
    LoggingService,
    {provide: ErrorHandler, useClass: SCAErrorHandler},
    {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthHeaderInterceptor,
    multi: true
    },
    DialogRef,
    EnvServiceProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
